import {
    type FC
} from "react";
import {
    View
} from "react-native";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    ItemPartContentProps,
    IItemContentProps
} from "../../type";
import {
    withItemContext
} from "../../context";
import stylesheet from "../../stylesheet";

const ItemContentBase: FC<ItemPartContentProps<IItemContentProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    return <View
        {...props}
        onLayout={(event) => {
            props.onLayout?.(event);

            context.onContentLayout(event.nativeEvent.layout.height);
        }}
        style={[
            style,
            stylesheet.content,
            context.isPressable ? stylesheet.inert : undefined,
            {
                gap: spaces.spacingXxs
            }
        ]}
    >
        {children}
    </View>;
};
export default withItemContext("content", ItemContentBase);
